import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import config from "../../config";
import { store } from "../../Store";

const env = process.env.HOST;

let sentryEnv = "";
if (env.includes("cv")) {
    if (env.includes("qa")) sentryEnv = "cv-qa";
    else if (env.includes("prod")) sentryEnv = "cv-production";
} else if (env.includes("uv")) {
    if (env.includes("staging")) sentryEnv = "uv-staging";
    else if (env.includes("prod")) sentryEnv = "uv-production";
}

//  Initialize Sentry
Sentry.init({
    dsn: config.sentryDsn,
    integrations: [new BrowserTracing()],
    // transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    transportOptions: {
        dbName: "cv-sentry-logs",
        maxQueueSize: 30,
    },
    tracesSampleRate: 1.0, // Adjust for production
    environment: sentryEnv,
    enabled:
        env.includes("prod") || env.includes("qa") || env.includes("staging"),
});

// Capture unhandled promise rejections
window.addEventListener("unhandledrejection", (event) => {
    logToSentry("Unhandled Promise Rejection", { error: event.reason });
});

// Capture console errors
window.addEventListener("error", (event) => {
    logToSentry("Console Error", { error: event.error });
});

window.onerror = (message, source, lineno, colno, error) => {
    if (error) {
        logToSentry(`Global excpection`, {});
    }
};

/**
 * Update Sentry User Context
 * This ensures that the latest user data is attached after login
 */
export const updateSentryUserContext = () => {
    try {
        const { auth } = store.getState();

        const authDetails = {
            id: auth.account.id,
            email: auth.account.email,
            username: auth.username,
            language: auth.account.language,
        };

        if (auth.username.length > 0 && auth.idToken.length > 0) {
            Sentry.setUser(authDetails);
        } else {
            Sentry.setUser(null); // Clear user context if logged out
        }
    } catch (error) {
        console.warn("Failed to update Sentry user context", error);
        Sentry.setUser(null);
    }
};

/**
 * Centralized Error Logging to Sentry
 * @param {string} message - Error message
 * @param {object} context - Additional error context (optional)
 */
export const logToSentry = (message, context = {}) => {
    const errorDetails = {
        errorMessage: message,
        pwaVersion: process.env.version,
        ...context,
    };
    Sentry.addBreadcrumb({
        category: "error",
        message: message,
        level: "error",
        data: errorDetails,
    });
    // console.error("Sentry Error Log:", errorDetails);
    Sentry.captureException(message, { extra: errorDetails });
};

export default Sentry;
